export const iconFontAwesomeHumanitarianRoadCircleXmark = (
	<i className="fa-solid fa-road-circle-xmark"></i>
);
